module.exports = "/images/job-loss.png?5a9a12aa363bf4cb839fcad9514464bb";